import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Subscription, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  constructor() { }
  private timeRemainingSubject = new BehaviorSubject<number>(0);
  timeRemaining$ = this.timeRemainingSubject.asObservable();
  private timerSub: Subscription | null = null;

  startTimer(duration: number) {
    this.stopTimer()
    this.timerSub = interval(1000).pipe(take(duration)).subscribe(timeElapsed => {
      this.timeRemainingSubject.next(duration - timeElapsed - 1);
    });
  }

  stopTimer() {
    this.timerSub?.unsubscribe();
    this.timerSub = null;
  }
}
